import { Box, Button, Stack, Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { BackButton } from '../components/BackButton'
import { PageContainer } from '../components/layout/PageContainer'
import YesNoAction from '../components/YesNoAction'
import { selectAllFarmerAccounts, selectCurrentFarmerAccount } from '../features/azure-b2c/storage'
import { TestIds } from '../testIds'
import { Quote } from '../features/quotes/storage/types'

export const RequestAQuoteSuccess = () => {
  const farmlandsAccounts = useSelector(selectAllFarmerAccounts)
  const currentAccount = useSelector(selectCurrentFarmerAccount)
  const navigate = useNavigate()

  const location = useLocation()

  // Access the quote object from state
  const { quote } = (location.state as { quote: Quote }) || {}

  const cartOrMessage = React.useMemo(() => {
    return (
      <YesNoAction
        display='Quote request sent'
        subheading={
          <Typography variant='h4' sx={{ mt: 4, mb: 2 }}>
            Thanks {farmlandsAccounts?.contactFirstName}! Your quote request is sent to your account
            manager.
          </Typography>
        }
        body={
          <Stack gap={2}>
            <Box>
              <Button
                variant='contained'
                onClick={() => {
                  navigate(`/quotes/${quote.id}`, {
                    state: {
                      quote: quote,
                    },
                  })
                }}
              >
                View Quote
              </Button>
            </Box>
          </Stack>
        }
      />
    )
  }, [currentAccount])

  return (
    <PageContainer data-testid={TestIds.pages.requestAQuoteSuccess}>
      <BackButton text='Products' onClick={() => navigate('/products')} />
      {cartOrMessage}
    </PageContainer>
  )
}
